import { LocaleService } from '../../services/locale/locale.service';

/**
 * Angular filter: localizeCurrency
 *
 * Replaces hardcoded `${{value}}` interpolation and the built-in `| currency` filter.
 * Uses Intl.NumberFormat via LocaleService so the symbol and formatting
 * are locale-aware (e.g. $12.50 in en-AU, $12.50 in en-US, 12,50 $ CA in fr-CA).
 *
 * Usage in templates:
 *   {{ booking.price | localizeCurrency }}            → uses venue currency from context
 *   {{ booking.price | localizeCurrency:'USD' }}      → forces USD formatting
 *
 * The currencyCode argument should be an ISO 4217 code (AUD, USD, EUR…).
 * When no currency code is supplied, formats as a plain decimal with no symbol (e.g. 12.50).
 */
export function localizeCurrencyFilter() {
  return function(amount: number, currencyCode: string): string {
    if (amount == null) return '';
    return LocaleService.formatCurrency(amount, currencyCode);
  };
}

localizeCurrencyFilter.$inject = [] as any;
